<template>
	<div class="home">
		<div class="top">
			<p class="top_word">此实名认证服务由司法电子证据云平台提供，如有问题可咨询该平台客服。</p>
			<img src="../assets/img/prompt.png" alt="">
			<h4>提示</h4>
			<p class="tip">根据《网络安全法》的要求,需要您完成实名认证后，方可继续使用网络服务</p>
		</div>
		<div class="inpDiv">
			<p class="clearfix">
				<i>*</i>
				<label for="">真实姓名：</label>
				<input type="text" placeholder="真实姓名" v-model="name">
			</p>
			<p class="clearfix">
				<i>*</i>
				<label for="">身份证号：</label>
				<input type="text" placeholder="身份证号" v-model="idcard">
			</p>
			<p class="clearfix">
				<i>*</i>
				<label for="">手机号：</label>
				<input type="tel" placeholder="手机号" v-model="tel">
			</p>
			<p class="clearfix">
				<i>*</i>
				<label for="">验证码：</label>
				<input type="text" placeholder="验证码" v-model="yzCard" style="width: 100px;">
				<el-button :disabled="isTrue" class="yzBtn" @click="getCode()">{{getMsgCode}}</el-button>
			</p>
		</div>
		<button v-if="!tjz" @click="submits()">提交</button>
		<button v-else>提交中</button>
		<!--<p>注:由司法电子证据云平台提供电子证据认证服务</p>-->
		<div class="bottom">
			<p>由司法电子证据云平台提供电子证据认证服务</p>
			<p>客服电话:010-60608644 工作日（9:00~18:00）</p>
		</div>
		<!-- 弹框 -->
		<div class="model" v-show="modelDiv">
			<div class="modelDiv">
				<h3>提交认证</h3>
				<h4>您是否确定提交信息无误？</h4>
				<p class="clearfix"><span @click="modelDiv = false">取消</span><span @click="submit()">确定</span></p>
			</div>
		</div>
	</div>
</template>
<script>
	// @ is an alias to /src
	import HelloWorld from '@/components/HelloWorld.vue'
	import axios from 'axios'
	export default {
		name: 'home',
		data() {
			return {
				isTrue: false,
				time2: 60,
				getMsgCode: '获取验证码',
				tjz: false,
				modelDiv: false,
				name: '',
				idcard: '',
				tel: '',
				yzCard: ''
			}
		},
		components: {
			HelloWorld
		},
		mounted: function() {
			document.title = "实名认证";
		},
		created: function() {
			this.authcode = this.$route.query.authcode;
			this.appkey = this.$route.query.appkey;
			sessionStorage.setItem("authcode", this.authcode);
			sessionStorage.setItem("appkey", this.appkey);
			this.getUserInfo();
			//通知此为实名页面
			this.onBack()
			//统计
			this.tj(this.appkey,'Authentication')
		},
		methods: {
			//调用方法
			onBack: function() {
				try {
					CSElectricProofJSMethodObject.onBack(1)
				} catch(e) {
					console.log('出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
				}
			},
			//短信验证码
			getCode() {
				//				alert(1)
				let self = this;
				var ppp = /^1[3|4|5|7|8|9][0-9]\d{4,8}$/
				if(self.tel !== '' && ppp.test(self.tel)) {
					//					alert(2)
					//禁止点击
					self.isTrue = true
					var text1 = sessionStorage.appkey + sessionStorage.token + self.tel + sessionStorage.userid + self.appsecret
					//					alert(text1)
					//验证手机号是否注册
					//					var  params  =  new  URLSearchParams();
					//					params.append('appkey',  sessionStorage.appkey);
					//					params.append('token',  sessionStorage.token);
					//					params.append('sign', $.md5(
					//						sessionStorage.token + sessionStorage.appkey + self.appsecret
					//					));
					//					params.append('mobile',  self.tel);
					//					params.append('userid',  sessionStorage.userid);
					this.$axios
						.post("/v2/checkMobile", {
							appkey: sessionStorage.appkey,
							token: sessionStorage.token,
							sign: $.md5(
								sessionStorage.token + sessionStorage.appkey + self.appsecret
							),
							userid: sessionStorage.userid,
							mobile: self.tel
						})
						.then(function(res) {
							if(res.data.code == 2000) {
								//								alert('成功')
								self.$toast("发送成功");
								//手机号未存在时可以获取验证码
								self.getYz();
							} else {
								self.$toast("手机号已存在");
								self.isTrue = false
							}
						})
						.catch(function(err) {
							console.log(err);
						});

				} else {
					self.$toast("手机号格式错误");
				}
			},
			getYz: function() {
				//				alert(4)
				let self = this;
				//				var  params  =  new  URLSearchParams();
				//				params.append('appkey',  sessionStorage.appkey);
				//				params.append('token',  sessionStorage.token);
				//				params.append('sign', $.md5(
				//					sessionStorage.token + sessionStorage.appkey + self.appsecret
				//				));
				//				params.append('mobile',  self.tel);
				//				axios.post("v2/sendMobileCode", params ).then(res => {
				//					console.log(res)
				//					if(res.data.code == 2000) {
				//						alert(5)
				//						self.getMsgCode = '等待(' + self.time2 + '秒)'
				//						let timer = setInterval(() => {
				//							self.time2--;
				//							self.getMsgCode = '等待(' + self.time2 + '秒)'
				//							if(self.time2 == 0) {
				//								clearInterval(timer);
				//								self.time2 = 60;
				//								self.getMsgCode = "获取验证码";
				//								self.isTrue = false
				//							}
				//						}, 1000)
				//					} else {
				//						self.$toast("验证码发送失败");
				//					}
				//				}, err => {
				//					console.log(err);
				//				})
				this.$axios
					.post("/v2/sendMobileCode", {
						appkey: sessionStorage.appkey,
						token: sessionStorage.token,
						sign: $.md5(
							sessionStorage.token + sessionStorage.appkey + self.appsecret
						),
						mobile: self.tel
					})
					.then(function(res) {
						console.log(res)
						if(res.data.code == 2000) {
							//							alert(5)
							self.getMsgCode = '等待(' + self.time2 + '秒)'
							let timer = setInterval(() => {
								self.time2--;
								self.getMsgCode = '等待(' + self.time2 + '秒)'
								if(self.time2 == 0) {
									clearInterval(timer);
									self.time2 = 60;
									self.getMsgCode = "获取验证码";
									self.isTrue = false
								}
							}, 1000)
						} else {
							self.$toast("验证码发送失败");
						}
					})
					.catch(function(err) {
						console.log(err);
					});
			},
			getUserInfo: function() {
				//				let self = this;
				this.$axios
					.post("/v2/getMemberInfo", {
						appkey: this.appkey,
						authcode: sessionStorage.authcode
					})
					.then(function(res) {
						if(res.data.code == 2001) {
							sessionStorage.setItem("userid", res.data.data.userid);
							sessionStorage.setItem("token", res.data.data.token);
						}
					})
					.catch(function(err) {

					});
			},
			submits: function() {
				this.modelDiv = true;
			},
			submit: function() {
				if(this.name == '') {
					this.$toast("名字不能为空");
					return false;
				}
				if(this.idcard == '') {
					this.$toast("身份证不能为空");
					return false;
				}
				let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
				if(!reg.test(this.idcard)) {
					this.$toast("身份证格式错误");
					return false;
				}
				if(this.tel == '') {
					this.$toast("手机号不能为空");
					return false;
				}
				if(this.yzCard == '') {
					this.$toast("验证码不能为空");
					return false;
				}
				let self = this;
				self.tjz = true;
				this.$axios.post("/v2/realAuth", {
					appkey: sessionStorage.appkey,
					token: sessionStorage.token,
					sign: $.md5(
						sessionStorage.token + sessionStorage.appkey + self.appsecret
					),
					userid: sessionStorage.userid,
					name: self.name,
					idcard: self.idcard,
					mobile: this.tel,
					idcode: this.yzCard
				}).then(function(res) {
					console.log(res.data);
					self.$toast(res.data.msg);
					self.tjz = false;
					if(res.data.code == 2001) {
						self.$router.push('./AuthenticationSuc?name=' + self.name + '&idcard=' + self.idcard); // 跳转到成功页
					}
				}).catch(function(err) {
					console.log(err);
				});
			}
		},
	}
</script>

<style scoped lang="less">
	.home {
		.top {
			padding: 0px 0 34px 0;
			background: #FFFFFF;
			box-shadow: 0 2px 4px 0 rgba(223, 223, 223, 0.50);
			>img {
				width: 51px;
				display: block;
				margin: 0 auto;
			}
			h4 {
				font-size: 14px;
				color: #333333;
				text-align: center;
				line-height: 20px;
				height: 20px;
				margin: 12px 0 5px 0;
			}
			.tip {
				font-size: 15px;
				color: #666666;
				line-height: 26px;
				padding: 0 24px;
			}
		}
		button {
			cursor: pointer;
			font-size: 16px;
			color: #FFFFFF;
			width: calc(~"100% - 48px");
			height: 42px;
			line-height: 42px;
			text-align: center;
			background: #19CBA6;
			border: 0;
			outline: none;
			margin: 93.5px auto 0 auto;
			display: block;
		}
		.yzBtn {
			width: 108px;
			margin: 0;
			height: 42px;
			line-height: 20px;
			text-align: center;
			float: right;
		}
		>p {
			font-size: 12px;
			color: #8B572A;
			width: calc(~"100% - 48px");
			margin: 9px auto;
			text-align: center;
		}
		.bottom {
			width: 100%;
			margin-top: 20px;
			p {
				text-align: center;
				&:nth-of-type(1) {
					font-size: 12px;
					color: #8B572A;
				}
				&:nth-of-type(2) {
					font-size: 12px;
					color: #999999;
					margin: 1px 0 20px 0;
				}
			}
		}
		.top_word {
			width: 100%;
			line-height: 20px;
			text-align: left;
			font-size: 12px;
			background: #19CBA6;
			word-break: break-all;
			color: #fff;
			margin: 0px auto;
			margin-bottom: 20px;
			    padding: 10px 24px;
			    box-sizing: border-box;
		}
		.inpDiv {
			margin-top: 12.5px;
			background: #FFFFFF;
			padding: 0 17.5px;
			p {
				padding-left: 9.2px;
				position: relative;
				i {
					color: red;
					position: absolute;
					left: 0;
					top: 50%;
					height: 10px;
					line-height: 10px;
					margin-top: -1px;
				}
				label {
					height: 46px;
					line-height: 46px;
					font-size: 14px;
					color: #666666;
					float: left;
					margin-right: 10px;
				}
				input {
					float: left;
					height: 46px;
					line-height: 46px;
					border: 0;
					background: transparent;
					outline: none;
					color: #333333;
					font-size: 16px;
				}
				&:nth-of-type(2) {
					border-top: 1px solid #EEEDED;
				}
			}
		}
	}
</style>